// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ns-datetime__popover {
  min-width: 320px;
  max-width: min(calc(100vw - 24px), 360px);
  max-height: calc(100vh - 24px);
  overflow-y: auto;
}

.ns-datetime__calendar .rdrCalendarWrapper {
  font-size: 13px;
  width: 100%;
}

.ns-datetime__calendar .rdrMonth {
  width: 100%;
}

.ns-datetime__calendar .rdrDayToday .rdrDayNumber span:after {
  background: #4c5fd5;
}

.ns-datetime__time {
  padding: 10px 14px;
  border-top: 1px solid #eef1f5;
}

.ns-datetime__time-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #6b7785;
  margin-bottom: 6px;
}

.ns-datetime__time-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ns-datetime__time-row .form-select {
  height: 38px;
  min-height: 38px;
  font-size: 0.875rem;
}

.ns-datetime__time-row .form-select:first-child,
.ns-datetime__time-row .form-select:nth-child(2) {
  flex: 1 1;
}

.ns-datetime__time-row .form-select:last-child {
  flex: 0 0 5.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DateTimePicker/DateTimePicker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,SAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".ns-datetime__popover {\n  min-width: 320px;\n  max-width: min(calc(100vw - 24px), 360px);\n  max-height: calc(100vh - 24px);\n  overflow-y: auto;\n}\n\n.ns-datetime__calendar .rdrCalendarWrapper {\n  font-size: 13px;\n  width: 100%;\n}\n\n.ns-datetime__calendar .rdrMonth {\n  width: 100%;\n}\n\n.ns-datetime__calendar .rdrDayToday .rdrDayNumber span:after {\n  background: #4c5fd5;\n}\n\n.ns-datetime__time {\n  padding: 10px 14px;\n  border-top: 1px solid #eef1f5;\n}\n\n.ns-datetime__time-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7785;\n  margin-bottom: 6px;\n}\n\n.ns-datetime__time-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ns-datetime__time-row .form-select {\n  height: 38px;\n  min-height: 38px;\n  font-size: 0.875rem;\n}\n\n.ns-datetime__time-row .form-select:first-child,\n.ns-datetime__time-row .form-select:nth-child(2) {\n  flex: 1 1 0;\n}\n\n.ns-datetime__time-row .form-select:last-child {\n  flex: 0 0 5.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
